<script>
  import Icon from "svelte-awesome";
  import { arrowLeft, chevronRight } from "svelte-awesome/icons";
</script>

<style>
  button {
    padding: 10px 5px;
    border-radius: 5px;
    background-color: #3498db;
    color: white;
  }
  .success-container { 
    width: 700px;
    margin: 0 auto;
    text-align: center;
    padding: 50px;
    -webkit-box-shadow: 10px 13px 81px -6px rgba(240,240,240,1);
    -moz-box-shadow: 10px 13px 81px -6px rgba(240,240,240,1);
    box-shadow: 10px 13px 81px -6px rgba(240,240,240,1);
  }
  .success-container span {
    color: #96df73;
    font-weight: 200;
    font-size: 2rem;
  }

  .success-container button{
    margin-top: 40px;
    background-color: #223646;
    border: 0;
    padding: 12px 40px;
    margin-left: 10px;
    font-size: 12px;
    border-radius: 0;
    display: block;
    margin: 0 auto;
  }
  @media (max-width: 426px) {
    .success-container { 
      width: 100%;
    }
  }
</style>

<div class="timesite-container">
  <div class="success-container">
    <span>PTO Sucessfully Sent!</span>
    <a href="/requestPTO">
      <button style="margin-top: 40px">Go Back</button>
    </a>
  </div>
</div>
